import * as React from "react";

function Tick(props) {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5965 0.390037L4.4365 7.30004L2.5365 5.27004C2.1865 4.94004 1.6365 4.92004 1.2365 5.20004C0.846504 5.49004 0.736503 6.00004 0.976503 6.41004L3.2265 10.07C3.4465 10.41 3.8265 10.62 4.2565 10.62C4.6665 10.62 5.0565 10.41 5.2765 10.07C5.6365 9.60004 12.5065 1.41004 12.5065 1.41004C13.4065 0.490037 12.3165 -0.319963 11.5965 0.380037V0.390037Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoTickIcon = React.memo(Tick);
export default MemoTickIcon;
